import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { Row, Space, Select } from "@masterteam/mt-design-react";

import DashboardCard from "../DashboardCard";
import { useIsAr } from "../../../Hooks";

import "./style.scss";

const LevelTwoObjectivesPerformance = ({
  data,
  kpiStatuses,
  projectStatuses,
}) => {
  const [isAr] = useIsAr();
  const [selectedObjectives, setSelectedObjectives] = useState([]);

  const getObjectiveList = () =>
    selectedObjectives?.length
      ? data?.Objectives?.filter((item) =>
          selectedObjectives?.some(
            (selectedObjective) => selectedObjective?.ID === item?.ID
          )
        )
      : data?.Objectives;

  return (
    <Space
      direction="vertical"
      className="level-two-objectives-performance"
      size="medium"
    >
      <Row
        size="large"
        align="center"
        justify="between"
        className="level-two-objectives-performance__header"
      >
        <div className="level-two-objectives-performance__title">
          <FormattedMessage id="dashboards.objectives-performance" />
        </div>

        <Space
          align="center"
          className="level-two-objectives-performance__field-wrapper"
        >
          <div className="level-two-objectives-performance__title">
            <FormattedMessage id="common.strategic-objectives" />
          </div>
          <Select
            options={data?.ObjectiveList}
            placeholder={<FormattedMessage id="common.strategic-objectives" />}
            getOptionLabel={(el) => (isAr ? el.ArabicName : el.EnglishName)}
            getOptionValue={(el) => el?.ID}
            onChange={(item) => {
              setSelectedObjectives(item);
            }}
            value={selectedObjectives}
            className="level-two-objectives-performance__select"
            isMulti
          />
        </Space>
      </Row>

      {getObjectiveList()?.length ? (
        <div className="level-two-objectives-performance__cards">
          {getObjectiveList()?.map((e) => (
            <DashboardCard
              data={e}
              kpiStatuses={kpiStatuses}
              projectStatuses={projectStatuses}
              key={e.ID}
              width="100%"
            />
          ))}
        </div>
      ) : (
        <Row
          justify="center"
          align="center"
          style={{ paddingTop: "16px", fontSize: "14px" }}
        >
          <FormattedMessage id="no-data" />
        </Row>
      )}
    </Space>
  );
};

export default LevelTwoObjectivesPerformance;
